import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {EmailSmsPlaceholderComponent} from "./email-sms-placeholder.component";


@NgModule({
  declarations: [EmailSmsPlaceholderComponent],
  imports: [
    CommonModule
  ],
  exports: [EmailSmsPlaceholderComponent]
})
export class EmailSmsPlaceholderModule { }
